import { types } from './actions';

const initialState = {
  showLeaseEntryModal: false,
  showLeaseMoveModal: false,
  showLeaseMergeModal: false,
  showLeaseAddModal: false,
  lease: null,
};

const leaseList = (state = initialState, action) => {
  switch (action.type) {
    case types.OPEN_LEASE_EDIT_MODAL: {
      const { payload: lease } = action;
      return {
        ...state,
        showLeaseEntryModal: true,
        lease,
      };
    }
    case types.CLOSE_LEASE_EDIT_MODAL: {
      return {
        ...state,
        showLeaseEntryModal: false,
        lease: null,
      };
    }

    case types.OPEN_LEASE_MOVE_MODAL: {
      const { payload: lease } = action;
      return {
        ...state,
        showLeaseMoveModal: true,
        lease,
      };
    }
    case types.CLOSE_LEASE_MOVE_MODAL: {
      return {
        ...state,
        showLeaseMoveModal: false,
        lease: null,
      };
    }

    case types.OPEN_LEASE_MERGE_MODAL: {
      const { payload: lease } = action;
      return {
        ...state,
        showLeaseMergeModal: true,
        lease,
      };
    }
    case types.CLOSE_LEASE_MERGE_MODAL: {
      return {
        ...state,
        showLeaseMergeModal: false,
        lease: null,
      };
    }

    case types.OPEN_LEASE_ADD_MODAL: {
      return {
        ...state,
        showLeaseAddModal: true,
      };
    }
    case types.CLOSE_LEASE_ADD_MODAL: {
      return {
        ...state,
        showLeaseAddModal: false,
        lease: null,
      };
    }
    default:
      return state;
  }
};

export default leaseList;
